<template>
  <Layout class="i-layout my-layout">
    <transition name="fade-quick">
      <div class="h64px">
        <Header
          class="i-layout-header"
          v-show="showHeader"
          v-resize="handleHeaderWidthChange"
          id="qwe"
        >
          <i-link to="/" class="logo-part">
            <!-- <img src="@/assets/logo.png" width="40" alt="" /> -->
            <span>{{ layoutTitle }}</span>
          </i-link>
          <div class="i-layout-sider-logo bbn" v-if="mutiFuncationMenu">
            <transition name="fade-quick">
              <i-link to="/">
                <img src="@/assets/images/logo-small.png" v-if="menuCollapse" />
                <img
                  src="@/assets/images/logo.png"
                  v-else-if="siderTheme === 'light'"
                />
                <img src="@/assets/images/logo-dark.png" v-else />
              </i-link>
            </transition>
          </div>
          <span :class="{ 'v-h': mutiFuncationMenu }">
            <i-header-logo v-if="isMobile && showMobileLogo" />
            <i-header-logo v-if="!isMobile && isHeaderStick && headerFix" />

            <i-header-reload
              class="ml20"
              v-if="!isMobile && showReload"
              @on-reload="handleReload"
            />
          </span>

          <span style="flex: 1" :class="{ 'v-h': mutiFuncationMenu }">
            <i-menu-head v-if="headerMenu && !isMobile" ref="menuHead" />
          </span>

          <!-- <el-button class="viewBigScreen" @click="viewBigScreen"
            >查看大屏</el-button
          > -->

          <div
            class="i-layout-header-right"
            style="color: white; display: flex"
          >
            <div class="role-selector">
              <el-select v-model="roleSelectV" placeholder="请选择">
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="getRoleLabel(item)"
                  :value="item.roleId"
                  :disabled="item.roleId === roleSelectV"
                >
                </el-option>
              </el-select>
            </div>

            <i-menu-head v-if="headerMenu && isMobile" />
            <i-header-log v-if="isDesktop && showLog" />
            <i-header-notice
              v-if="showNotice"
              :title="newNumber"
              @increase="haveChange"
            />
            <i-header-user />
            <i-header-i18n v-if="showI18n" />
            <!-- <i-header-setting v-if="enableSetting && !isMobile" /> -->
          </div>
        </Header>
      </div>
    </transition>

    <div class="my-layout-main">
      <Sider
        v-if="!isMobile && !hideSider"
        class="i-layout-sider"
        :width="menuSideWidth"
      >
        <i-menu-side :hide-logo="isHeaderStick && headerFix && showHeader" />
      </Sider>

      <div class="my-layout-main-content" ref="mainScrollContainer">
        <Content class="i-layout-content" :class="contentClasses">
          <div
            v-if="info.buttonPermision.develop_platform && qxApiBaseURL"
            style="margin: 45px 12px 12px 12px"
          >
            <iframe
              ref="callCentreIframe"
              :src="qxApiBaseURL"
              width="100%"
              height="130px"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
          <transition name="fade-quick">
            <i-tabs
              v-if="tabs"
              v-show="showHeader"
              @on-reload="handleReload"
              :class="{ 'l0 w100': mutiFuncationMenu }"
            />
          </transition>

          <div class="i-layout-content-main">
            <!--<button @click="texCustomerService">文本客服</button>-->
            <keep-alive :include="keepAlive">
              <router-view v-if="loadRouter" />
            </keep-alive>
          </div>
        </Content>
        <i-copyright />
      </div>
    </div>

    <div v-if="isMobile && !hideSider">
      <Drawer
        v-model="showDrawer"
        placement="left"
        :closable="false"
        :class-name="drawerClasses"
      >
        <i-menu-side />
      </Drawer>
    </div>

    <!--  文本客服  -->
    <!--    <el-drawer
            title="我是标题"
            :visible.sync="drawer"
            :with-header="false"
            size="60%">
          <iframe
              v-if="qxkfApiBaseURL"
              :src="qxkfApiBaseURL"
              ref="textIframe"
              style="width: 100%; height: 100%"
              frameborder="0"
              allow="microphone"
          ></iframe>
        </el-drawer>-->
    <!-- 悬浮按钮 -->
    <!-- <div
        class="float-btn"
        @click="toggleChatWindow"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
    >
      <i class="el-icon-chat-dot-round"></i>
      <transition name="fade">
        <div v-show="showTooltip" class="tooltip">在线客服</div>
      </transition>
    </div> -->

    <!-- 聊天窗口 -->
    <div
      v-show="windowVisible"
      ref="chatWindow"
      class="chat-window"
      :style="windowStyle"
    >
      <!-- 标题栏 -->
      <div class="title-bar" @mousedown="startDrag">
        <span>{{ isMinimized ? "已最小化" : "在线文本客服" }}</span>
        <div class="controls">
          <!--          <el-button type="primary" @click="toggleMinimize" >−</el-button>-->
          <el-button type="primary" @click="closeWindow">×</el-button>
        </div>
      </div>

      <div class="message-area">
        <iframe
          v-if="qxkfApiBaseURL"
          :src="qxkfApiBaseURL"
          ref="textIframe"
          style="width: 100%; height: 100%"
          frameborder="0"
          allow="microphone"
        ></iframe>
      </div>

      <!--      &lt;!&ndash; 输入区域 &ndash;&gt;
            <div v-show="!isMinimized" class="input-area">
              <el-input
                  v-model="newMessage"
                  type="textarea"
                  :rows="2"
                  placeholder="输入消息..."
                  @keyup.enter.native="sendMessage"
              ></el-input>
              <el-button type="primary" @click="sendMessage">发送</el-button>
            </div>-->
    </div>
  </Layout>
</template>
<script>
import iMenuHead from "./menu-head";
import iMenuSide from "./menu-side";
import iHeaderLogo from "./header-logo";
import iHeaderCollapse from "./header-collapse";
import iHeaderReload from "./header-reload";
import iHeaderBreadcrumb from "./header-breadcrumb";
import iHeaderSearch from "./header-search";
import iHeaderLog from "./header-log";
import iHeaderFullscreen from "./header-fullscreen";
import iHeaderNotice from "./header-notice";
import iHeaderUser from "./header-user";
import iHeaderI18n from "./header-i18n";
import iHeaderSetting from "./header-setting";
import iTabs from "./tabs";
import iCopyright from "@/components/copyright";
import { connectWebSocket } from "@/libs/websocket";

import { mapState, mapGetters, mapMutations } from "vuex";
import Setting from "@/setting";

import { requestAnimation } from "@/libs/util";
import { getRoles } from "@/api/adminSetting";
import {
  getHeaderName,
  getMenuSider,
  getSiderSubmenu,
  getSiderOpenNames,
} from "@/libs/ab-system";
import util from "@/libs/util";
import { Base64 } from "js-base64";

export default {
  name: "BasicLayout",
  components: {
    iMenuHead,
    iMenuSide,
    iCopyright,
    iHeaderLogo,
    iHeaderCollapse,
    iHeaderReload,
    iHeaderBreadcrumb,
    iHeaderSearch,
    iHeaderUser,
    iHeaderI18n,
    iHeaderLog,
    iHeaderFullscreen,
    iHeaderSetting,
    iHeaderNotice,
    iTabs,
  },
  data() {
    return {
      drawer: false,
      qxkfApiBaseURL: "",
      qxApiBaseURL: `http://49.7.215.51:9982${Setting.qxApiBaseURL}/ATClient_demo.html`,
      //imgBaseUrl: Setting.apiBaseURL + "/sys/sysFile/download?fileId=",
      showDrawer: false,
      ticking: false,
      isDark: false,
      headerVisible: true,
      oldScrollTop: 0,
      isDelayHideSider: false, // hack，当从隐藏侧边栏的 header 切换到正常 header 时，防止 Logo 抖动
      loadRouter: true,
      apiBaseURL: Setting.devServerProxyUrl || Setting.apiBaseURL, // 跳转开发设计平台，如果代理模式调转代理地址，否则直接跳转后台地址
      imgBaseUrl: Setting.apiBaseURL + "/sys/sysFile/download?fileId=",
      number: 0,
      newNumber: 0,
      userInfoLoaded: false,
      userMenuList: [],
      menuList: [],
      extendMenuList: [],
      roleSelectV: "管理员",
      roleList: [],
      messageType: {
        SEND_MESSAGE: "SEND_MESSAGE", //话务条发送消息
        WBCTOAGENT: "WBCTOAGENT", //在线文本客服-打开聊天框
        TRANSFERWORK: "TRANSFERWORK", //在线文本客服-一件转工单
        ERROR: "ERROR", //错误信息
        COOKIE: "COOKIE", //COOKIE
      },
      wecToAgentMsg: {},
      showTooltip: false,
      windowVisible: false,
      isMinimized: false,
      isDragging: false,
      newMessage: "",
      messages: [],
      windowStyle: {
        left: "100px",
        top: "100px",
        opacity: 1,
      },
      dragStartPos: { x: 0, y: 0 },
    };
  },
  computed: {
    ...mapState("admin/layout", [
      "siderTheme",
      "headerTheme",
      "headerStick",
      "tabs",
      "tabsFix",
      "siderFix",
      "headerFix",
      "mutiFuncationMenu",
      "headerHide",
      "headerMenu",
      "isMobile",
      "isTablet",
      "isDesktop",
      "menuCollapse",
      "showMobileLogo",
      "showSearch",
      "showNotice",
      "showFullscreen",
      "showSiderCollapse",
      "showBreadcrumb",
      "showLog",
      "showI18n",
      "showReload",
      "enableSetting",
      "openMsgBoxOnNewMsg",
    ]),
    ...mapState("admin/page", ["keepAlive"]),
    ...mapGetters("admin/menu", ["hideSider"]),
    ...mapState("admin/user", ["info"]),
    // 如果开启 headerMenu，且当前 header 的 hideSider 为 true，则将顶部按 headerStick 处理
    // 这时，即使没有开启 headerStick，仍然按开启处理
    isHeaderStick() {
      let state = this.headerStick;
      if (this.hideSider) state = true;
      return state;
    },
    showHeader() {
      let visible = true;
      if (this.headerFix && this.headerHide && !this.headerVisible)
        visible = false;
      return visible;
    },
    headerClasses() {
      return [
        `i-layout-header-color-${this.headerTheme}`,
        {
          "i-layout-header-fix": this.headerFix,
          "i-layout-header-fix-collapse": this.headerFix && this.menuCollapse,
          "i-layout-header-mobile": this.isMobile,
          "i-layout-header-stick": this.isHeaderStick && !this.isMobile,
          "i-layout-header-with-menu": this.headerMenu,
          "i-layout-header-with-hide-sider":
            this.hideSider || this.isDelayHideSider,
          "w100 l0": this.mutiFuncationMenu,
        },
      ];
    },
    headerStyle() {
      const menuWidth = this.isHeaderStick
        ? 0
        : this.menuCollapse
        ? 80
        : Setting.menuSideWidth;
      return this.isMobile || !this.headerFix
        ? {}
        : {
            width: `calc(100% - ${menuWidth}px)`,
            backgroundImage: "url(" + require("@/assets/images/top1.png") + ")",
            backgroundSize: "100% 100%",
          };
    },
    siderClasses() {
      return {
        "i-layout-sider-fix": this.siderFix,
        "i-layout-sider-dark": this.siderTheme === "dark",
        hide: this.mutiFuncationMenu,
      };
    },
    contentClasses() {
      return {
        "i-layout-content-fix-with-header": this.headerFix,
        "i-layout-content-with-tabs": this.tabs,
        "i-layout-content-with-tabs-fix": this.tabs && this.tabsFix,
      };
    },
    insideClasses() {
      return {
        "i-layout-inside-fix-with-sider": this.siderFix,
        "i-layout-inside-fix-with-sider-collapse":
          this.siderFix && this.menuCollapse,
        "i-layout-inside-with-hide-sider": this.hideSider,
        "i-layout-inside-mobile": this.isMobile,
        pl0: this.mutiFuncationMenu,
      };
    },
    drawerClasses() {
      let className = "i-layout-drawer";
      if (this.siderTheme === "dark") className += " i-layout-drawer-dark";
      return className;
    },
    menuSideWidth() {
      return this.menuCollapse ? 80 : Setting.menuSideWidth;
    },
    // 根据角色 展示“网格化智能管理平台”
    layoutTitle() {
      // 网格长、网格员、兼职网格员、综治村社管理员、综治乡镇管理员、综治区管理员
      const zz = ["jzwgy", "wgz", "zzqjgly", "scgly", "cbdw-xcgly", "zzqjgly"];
      const isZZRole = zz.includes(this.info.currentRole);

      const title1 = process.env.VUE_APP_TITLE || "南康区民意速办综合管理平台";
      const title2 = process.env.VUE_APP_ZZ_TITLE;
      return isZZRole ? title2 : title1;
    },
  },
  watch: {
    hideSider() {
      this.isDelayHideSider = true;
      setTimeout(() => {
        this.isDelayHideSider = false;
      }, 0);
    },
    $route(to, from) {
      if (to.name === from.name && to.meta.title === to.meta.title) {
        // 相同路由，不同参数，跳转时，重载页面
        if (Setting.sameRouteForceUpdate) {
          this.handleReload();
        }
      }
    },
    number: function(newVal, o) {
      if (o && newVal > o) {
        // this.open()
      }
      this.newNumber = newVal;
    },
    roleSelectV: {
      handler(newVal) {
        this.initPage(newVal);
      },
    },
    "info.buttonPermision": {
      handler(newVal, oldVal) {
        if (oldVal == null && newVal != null && newVal.develop_platform) {
          //console.log("777", oldVal == null && newVal != null && newVal.develop_platform)
          //拨打电话
          //let targetWindow = document.getElementById('myIframe').contentWindow// 发送消息
          /*let targetWindow = this.$refs.callCentreIframe.contentWindow// 发送消息
        targetWindow.postMessage('Hello from parent!', 'workOrder');*/

          const _this = this;
          setTimeout(() => {
            let targetWindow = _this.$refs.callCentreIframe.contentWindow; // 发送消息
            const msgData = {
              type: this.messageType.COOKIE,
              content: util.cookies.getAll().Authorization,
            };
            //console.log('targetWindow', targetWindow)
            targetWindow.self.postMessage(msgData, this.qxApiBaseURL);
            //console.log('COOKIE发送成功', msgData)
          }, 3000);
        }
      },
      deep: true,
    },
  },
  created() {
    //获取角色列表
    this.getRoles();

    window.AbBpmGridUtil.init();
    this.$store.commit("admin/menu/setAllMenuBadge", []);
    if (this.isTablet && this.showSiderCollapse) this.updateMenuCollapse(true);

    this.initPage();

    //通知 2 获取通知总条数
    // this.abHttpUtil
    //   .get("/oa/oAInstationMsg/getInstationMsg?type=2")
    //   .then(res => {
    //     this.number = Number(res.data.totalCount);
    //   });
    this.getLatestNum();
    //   setInterval(()=>{
    //       this.getLatestNum(true);
    //   },5*60*1000);
    //   },1000);

    this.$root.$on("getLatestNum", this.getLatestNum);
  },
  methods: {
    ...mapMutations("admin/layout", ["updateMenuCollapse"]),
    ...mapMutations("admin/page", ["keepAlivePush", "keepAliveRemove"]),
    ...mapMutations("admin/layout", ["updateLayoutSetting"]),
    initPage(roleId) {
      // 主框架打开的时候 加载菜单
      var thisVue = this;
      var denfer = thisVue.abHttpUtil.postForm("/org/userResource/userMsg", {
        system: "oa",
        roleId,
      });
      denfer.then(
        (result) => {
          // 无登录权限则跳转登录
          if (!result.isOk) {
            thisVue.$router.push({
              name: "login",
              query: { redirect: thisVue.$route.fullPath },
            });
            if (result.code != "401") {
              thisVue.$Message.error(result.msg);
            }
            return;
          }
          var userMsg = result.data;
          // 放入个人信息
          localStorage.setItem(
            "userInfo",
            JSON.stringify({
              fullname: userMsg.user.fullname,
              orgList: userMsg.orgList,
              user: userMsg.user,
              sysSeatsConfig: userMsg.sysSeatsConfig,
              sysCallCenterConfig: userMsg.sysCallCenterConfig,
              roleId: roleId,
              currentRole: userMsg.currentRole.alias,
              currentOrg: userMsg.currentOrg || {},
            }),
          );

          // TODO 将权限放到缓存中——目前没有用到，先注释
          /*if (window.localStorage) {
              window.localStorage.setItem(
                "buttonPermision",
                JSON.stringify(userMsg.buttonPermision)
              );
            }*/

          // 创建websocket连接
          try {
            connectWebSocket(userMsg.user.id);
          } catch (error) {
            console.log(error);
          }

          const userDb = this.$store.dispatch("admin/db/database", {
            user: true,
          });
          userDb.then((db) => {
            this.handMenuTitle(userMsg.userMenuList);
            db.set("userMenuList", userMsg.userMenuList).write();
            db.set("buttonPermision", userMsg.buttonPermision).write();
          });
          this.$store.dispatch("admin/user/set", {
            id: userMsg.user.id,
            name: userMsg.user.fullname,
            buttonPermision: userMsg.buttonPermision,
            currentOrg: userMsg.currentOrg,
            orgList: userMsg.orgList,
            menuList: userMsg.userMenuList,
            signature: userMsg.user.signature,
            avatar: userMsg.user.photo
              ? this.imgBaseUrl + userMsg.user.photo
              : require("@/assets/images/avatar.png"),

            autograph: userMsg.user.autograph,
            signatureKey: userMsg.user.signatureKey,
            isSign: userMsg.user.isSign,
            autographStatus: userMsg.user.autographStatus,
            sysSeatsConfig: userMsg.sysSeatsConfig,
            sysCallCenterConfig: userMsg.sysCallCenterConfig,
            currentRole: userMsg.currentRole.alias,
          });

          this.userInfoLoaded = true;

          // 根据当前路由设置菜单
          const headerName = getHeaderName(
            this.$route.fullPath,
            userMsg.userMenuList,
          );
          if (headerName) {
            const menuSider = getMenuSider(userMsg.userMenuList, headerName);

            this.$store.commit("admin/menu/setSider", menuSider);
            this.$store.commit("admin/menu/setHeaderName", headerName);
            this.$store.commit(
              "admin/menu/setActivePath",
              this.$route.fullPath,
            );

            const openNames = getSiderOpenNames(
              this.$route.fullPath,
              menuSider,
            );
            if (openNames.length > 0) {
              this.$store.commit("admin/menu/setOpenNames", openNames);
            }
          }

          // 加到扩展菜单中
          this.userMenuList = userMsg.userMenuList;

          this.initMutiFunctionMenu();
          if (userMsg.pwdIsexpire) {
            thisVue.expireData(userMsg.pwdIsexpire, userMsg.user.id);
          }
        },
        function(code) {
          thisVue.$Message.error("请求失败" + code);
        },
      );
    },

    getRoleLabel(item) {
      if (item.deptName) return `${item.deptName}-${item.roleName}`;
      return item.roleName;
    },

    expireData(flg, id) {
      this.$router.push({ path: "/user/updatePassword/" + id + "/" + flg });
      return;
    },

    initMutiFunctionMenu(words) {
      words = words || "";
      this.menuList = [];
      this.extendMenuList = [];

      for (var i = 0; i < this.userMenuList.length; i++) {
        var menu = this.userMenuList[i];
        var tempMenu = {
          title: menu.name,
          children: [],
          icon: menu.icon,
        };

        this.extendMenuList.push(tempMenu);

        var hasMatch = false;

        for (var j = 0; j < menu.children.length; j++) {
          var subMenu = menu.children[j];
          var tempSubMenu = {
            title: subMenu.name,
            path: tempMenu.children.length == 0 ? subMenu.url : "",
            children: [],
            icon: subMenu.icon || "ios-list-box",
          };

          var hasSubMatch = false;
          var hasSubSubMatch = false;

          if (subMenu.name.indexOf(words) >= 0) {
            hasMatch = true;
            hasSubMatch = true;
          }

          tempMenu.children.push(tempSubMenu);

          for (var k = 0; k < subMenu.children.length; k++) {
            var subSubMenu = subMenu.children[k];

            if (subSubMenu.name.indexOf(words) >= 0) {
              hasMatch = true;
              hasSubMatch = true;
              hasSubSubMatch = true;

              tempMenu.children.push({
                title: "　　　" + subSubMenu.name,
                path: subSubMenu.url,
                // icon: subSubMenu.icon || "ios-list-box",
              });
            }

            if (this.menuList.length <= 10) {
              this.menuList.push({
                title: subSubMenu.name,
                path: subSubMenu.url,
                icon: subSubMenu.icon || "ios-list-box",
              });
            }
          }

          if (!hasSubMatch && !hasSubSubMatch) {
            tempMenu.children.splice(tempMenu.children.length - 1, 1);
          }
        }

        if (!hasMatch) {
          this.extendMenuList.splice(this.extendMenuList.length - 1, 1);
        }
      }
    },
    handleScroll() {
      if (!this.headerHide) return;

      const scrollTop =
        document.body.scrollTop + document.documentElement.scrollTop;

      if (!this.ticking) {
        this.ticking = true;
        requestAnimation(() => {
          if (this.oldScrollTop > scrollTop) {
            this.headerVisible = true;
          } else if (scrollTop > 300 && this.headerVisible) {
            this.headerVisible = false;
          } else if (scrollTop < 300 && !this.headerVisible) {
            this.headerVisible = true;
          }
          this.oldScrollTop = scrollTop;
          this.ticking = false;
        });
      }
    },
    handleHeaderWidthChange() {
      const $breadcrumb = this.$refs.breadcrumb;
      if ($breadcrumb) {
        $breadcrumb.handleGetWidth();
        $breadcrumb.handleCheckWidth();
      }
      const $menuHead = this.$refs.menuHead;
      if ($menuHead) {
        $menuHead.handleGetMenuHeight();
      }
    },
    handleReload() {
      // 针对缓存的页面也生效
      const isCurrentPageCache = this.keepAlive.indexOf(this.$route.name) > -1;
      const pageName = this.$route.name;
      if (isCurrentPageCache) {
        this.keepAliveRemove(pageName);
      }
      this.loadRouter = false;
      this.$nextTick(() => {
        this.loadRouter = true;
        if (isCurrentPageCache) {
          this.keepAlivePush(pageName);
        }
      });
    },
    haveChange(total) {
      this.newNumber = total;
    },
    getLatestNum(isJob) {
      this.abHttpUtil
        .get("/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5")
        .then((res) => {
          if (res.isOk) {
            var oldNumber = this.number;
            this.number = Number(res.data.totalCount);
            // this.number = this.number + 1;
            this.newNumber = this.number;
            if (
              this.openMsgBoxOnNewMsg &&
              isJob &&
              oldNumber < this.newNumber
            ) {
              // 自动弹出消息盒子
              if (
                document.querySelectorAll(".ivu-notifications-transfer")[0]
                  .style.display == "none"
              ) {
                document.querySelectorAll(".ivu-notifications-rel")[0].click();
              }
            }
          }
        });
    },
    handMenuTitle(menuList) {
      if (!menuList || menuList.length < 1) return;

      for (var i = 0, menu; (menu = menuList[i++]); ) {
        menu.title = menu.name;
        if (menu.children) {
          this.handMenuTitle(menu.children);
        }
      }
    },
    async getRoles() {
      let res = await getRoles();
      if (res.isOk) {
        this.roleList = res.data.filter((item) => item.alias !== "xcx-user");
        this.roleSelectV = this.roleList[0].roleId;
      } else {
        this.$message.error(res.msg);
      }
    },
    //监听话务条发来的message
    handleMessage(event) {
      /*console.log('event', event);
      console.log('window.location.origin', window.location.origin);
      console.log('window.location.origin', event.origin != window.location.origin)
      console.log('http://49.7.215.51:9982', event.origin != 'http://49.7.215.51:9982')*/
      /*if (event.origin != window.location.origin || event.origin != this.qxApiBaseURL || event.origin != 'http://49.7.215.51:9982') {
        return; //  安全检查，忽略来自非预期 origin 的消息
      }*/
      //  处理接收到的消息
      console.log("Received message:", event.data);
      //振铃，收到话务条消息
      if (event.data.type === this.messageType.SEND_MESSAGE) {
        this.$router.push({
          path: "/orderManagement/createOrder", //统一的办理页面，后面的办理全用这个页面
          query: { openScreen: true, ...event.data.content },
        });
      }
      //在线文本客服,开启会话,打开聊天框
      if (event.data.type === this.messageType.WBCTOAGENT) {
        !this.windowVisible && this.toggleChatWindow();
        //WBC_RECV;FROM=42916735;TO=6286;MSG=5a+55pa55aSx5Y6754Sm54K5;TIME=2025-03-14 14:39:18;CMD=CHAT_BLUR;CALLID=20250314143228095;
        //this.wecToAgentMsg = this.getWbcMessage(event.data.content)
        //console.log('event.data.content', event.data.content)
        this.$nextTick(() => {
          this.callCenterToText(event.data.content);
        });
      }
      //在线文本客服,一件转工单
      if (event.data.type === this.messageType.TRANSFERWORK) {
        this.$router.push({
          path: "/orderManagement/createOrder", //统一的办理页面，后面的办理全用这个页面
          query: { openScreen: true, sessionId: event.data.content },
        });
      }
      if (event.data.type === this.messageType.ERROR) {
        this.$Message.error(event.data.content);
      }
    },
    //处理消息
    getWbcMessage(str) {
      const parts = str.split(";"); // 结果: ["WBC_RECV", "FROM=42916735", "TO=6286", ...]
      const result = {};
      parts.forEach((part) => {
        const [key, value] = part.split("=");
        result[key] = value || ""; // 处理无值情况
      });
      if (result.MSG) {
        result.MSG = decodeURIComponent(result.MSG.replace(/\+/g, "%20"));
      }
      result.TIME = new Date(result.TIME).toISOString();
      return result;
    },
    //调用话务条拨打电话
    callNumber(callNumber) {
      let targetWindow = this.$refs.callCentreIframe.contentWindow; // 发送消息
      const msgData = {
        type: this.messageType.SEND_MESSAGE,
        content: { callNumber },
      };
      //console.log('targetWindow', targetWindow)
      targetWindow.self.postMessage(msgData, this.qxApiBaseURL);
    },
    //提供给强讯话务条调用
    callCenterToText(message) {
      //调用文本iframe话务条中方法
      const textIframe = this.$refs.textIframe;
      //iframe.onload = () => {
      const iframeWindow = textIframe.contentWindow;
      console.log("textIframe.contentWindow", iframeWindow);
      //console.log('textIframe.contentWindow.myChat_i', iframeWindow.myChat_i)
      //console.log('onReceive_message调用判断前')
      //if (typeof iframeWindow.onReceive_message === 'function') {
      // 调用iframe内部的方法
      console.log("myChat_i.onReceive_message调用前");
      iframeWindow.myChat_i.onReceive_message(message);
      console.log("myChat_i.onReceive_message调用完成");
      /*} else {
        console.error('someMethod not found');
      }*/
      //};
    },
    toggleChatWindow() {
      this.windowVisible = !this.windowVisible;
      this.isMinimized = false;
      this.texCustomerService();
    },
    texCustomerService() {
      //打开iframe drawer
      //this.drawer = true
      //http://49.7.214.121:18090/ut_imcc/popup_wxc/agent_chat.html?cmd=popup_chat&from=47117382&to=8600&info=
      const { sysSeatsConfig, sysCallCenterConfig } = this.info;
      //单点登录在线文本客服
      let uid = sysSeatsConfig.userNo,
        pwd = sysSeatsConfig.password,
        ext = sysSeatsConfig.loginExtNo,
        from = this.wecToAgentMsg.FROM,
        to = this.wecToAgentMsg.TO;
      // http://49.7.214.121:18090/login/login_sso.html?cmd=CRM&uid=8600&pwd=UltraCRM@2020&ext=601&url=L3V0X2ltY2MvcG9wdXBfd3hjL2FnZW50X2NoYXQuaHRtbD9jbWQ9cG9wdXBfY2hhdCZmcm9tPTQ3MTE3MzgyJnRvPTg2MDAmaW5mbz0=
      let strHost = `http://49.7.215.51:9982/login/login_sso.html?cmd=CRM&uid=${uid}&pwd=${pwd}&ext=${ext}&url=`,
        strUrl = `/ut_imcc/popup_wxc/agent_chat.html?cmd=popup_chat&from=${from}&to=${to}&info=`;
      let strSSOUrl =
        strHost + Base64.encode(strUrl) + `&timestampNow=${Date.now()}`;
      //console.log('strSSOUrl', strSSOUrl);
      this.qxkfApiBaseURL = strSSOUrl;
    },
    startDrag(e) {
      if (this.isMinimized) return;

      this.isDragging = true;
      const rect = this.$refs.chatWindow.getBoundingClientRect();
      this.dragStartPos = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      this.windowStyle.opacity = 0.8;
    },

    handleDrag(e) {
      if (!this.isDragging) return;

      const maxX = window.innerWidth - this.$refs.chatWindow.offsetWidth;
      const maxY = window.innerHeight - this.$refs.chatWindow.offsetHeight;

      let newX = e.clientX - this.dragStartPos.x;
      let newY = e.clientY - this.dragStartPos.y;

      newX = Math.max(0, Math.min(newX, maxX));
      newY = Math.max(0, Math.min(newY, maxY));

      this.windowStyle.left = `${newX}px`;
      this.windowStyle.top = `${newY}px`;
    },

    stopDrag() {
      if (!this.isDragging) return;

      this.isDragging = false;
      this.windowStyle.opacity = 1;
      this.savePosition();
    },

    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
      if (!this.isMinimized) this.savePosition();
    },

    closeWindow() {
      this.windowVisible = false;
      this.isMinimized = false;
      this.savePosition();
    },

    sendMessage() {
      if (this.newMessage.trim()) {
        this.messages.push({
          content: this.newMessage,
          timestamp: new Date().toISOString(),
        });
        this.newMessage = "";
      }
    },

    savePosition() {
      localStorage.setItem(
        "chatPos",
        JSON.stringify({
          x: parseFloat(this.windowStyle.left),
          y: parseFloat(this.windowStyle.top),
        }),
      );
    },

    loadPosition() {
      const pos = JSON.parse(localStorage.getItem("chatPos"));
      if (pos) {
        this.windowStyle.left = `${pos.x}px`;
        this.windowStyle.top = `${pos.y}px`;
      }
    },
    viewBigScreen() {
      const link = "http://10.193.202.152:9982/bigScreen/#/";
      window.open(link, "_blank");
    },
  },

  mounted() {
    document.addEventListener("scroll", this.handleScroll, { passive: true });
    //话务条接受来自iframe的消息
    window.addEventListener("message", this.handleMessage, false);
    //其它组件调用iframe话务条拨打
    this.$bus.$on("callNumber", this.callNumber);
    // 在组件挂载后将方法暴露给全局对象
    window.callCenterToText = this.callCenterToText;

    this.loadPosition();
    window.addEventListener("mousemove", this.handleDrag);
    window.addEventListener("mouseup", this.stopDrag);
    this.$bus.$on("request-scroll-container", (callback) => {
      const container = this.$refs.mainScrollContainer;
      if (container) {
        callback({
          element: container,
          scrollTo: (options) => container.scrollTo(options),
          getPosition: () => ({
            top: container.scrollTop,
            height: container.clientHeight,
          }),
        });
      }
    });
    /*let msg = 'WBC_RECV;FROM=42916735;TO=6286;MSG=5a+55pa55aSx5Y6754Sm54K5;TIME=2025-03-14 14:39:18;CMD=CHAT_BLUR;CALLID=20250314143228095;'
    this.wecToAgentMsg = this.getWbcMessage(msg)
    console.log(this.wecToAgentMsg)*/
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.handleScroll);
    // 在组件销毁前移除对全局对象的引用
    if (window.callCenterToText === this.callCenterToText) {
      delete window.callCenterToText;
    }

    window.removeEventListener("mousemove", this.handleDrag);
    window.removeEventListener("mouseup", this.stopDrag);
    this.$bus.$off("request-scroll-container");
  },
};
</script>

<style lang="less" scoped>
.head-img {
  z-index: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.i-layout-content {
  display: flex;
  flex-direction: column;
  // height: calc(100% - 22px);
  height: 100%;

  .i-layout-content-main {
    flex: 1;
    height: calc(100% - 78px);
    overflow-y: auto;
    margin-top: 60px !important;
  }
}

.role-selector {
  margin-right: 1rem;

  /deep/ .el-input__inner {
    background-color: transparent;
    color: #fff;
    border-color: #fff;
  }
  /deep/ .el-input__suffix {
    top: -2px;
  }
}

/deep/ .i-layout-tabs-main {
  padding: 14px 0;
}

/deep/ .ivu-tabs-nav {
  display: flex;

  .ivu-tabs-tab {
    display: flex;
    align-items: center;
    padding: 2px 14px 3px !important;

    .i-layout-tabs-title {
      display: flex !important;
      align-items: center;
    }

    .ivu-tabs-close {
      top: 0 !important;
    }
  }
}

///////////////////////////////////////////////////////
.h64px {
  height: 64px;
  z-index: 99;

  .logo-part {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    margin-left: 1rem;

    span {
      margin-left: 0.5rem;
    }
  }
}

.i-layout-header {
  position: fixed !important;
  top: 0;
  // background-color: #b1bcd4;
  background: url("../../assets/images/top.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.my-layout {
  display: flex;
  flex-direction: column !important;

  .my-layout-main {
    height: calc(~"100vh - 64px");
    display: flex;

    .my-layout-main-content {
      min-height: calc(~"100vh - 64px");
      flex: 1;
      overflow: hidden;
    }
  }
}

.float-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #409eff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
  z-index: 9999;
}

.float-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.tooltip {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.chat-window {
  position: fixed;
  width: 50%;
  height: 60%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 9998;
  transition: opacity 0.2s;
}

.title-bar {
  padding: 12px;
  background: #409eff;
  color: white;
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px 8px 0 0;
}

.message-area {
  flex: 1;
  //overflow-y: auto;
  //padding: 12px;
}

.input-area {
  border-top: 1px solid #eee;
  padding: 12px;
  display: flex;
  gap: 8px;
}

.message {
  margin: 8px 0;
  padding: 8px;
  background: #f5f7fa;
  border-radius: 4px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.viewBigScreen {
  width: 84px;
  height: 36px;
  padding: 5px 10px;
  margin-right: 12px;
  background-color: transparent;
  color: #fff;
  border-color: #fff;
}
</style>
